// Validador de DNI/NIE español (con letra de control)
const TABLE = "TRWAGMYFPDXBNJZSQVHLCKE";
const DNI_RE = /^\d{8}[A-Z]$/;
const NIE_RE = /^[XYZ]\d{7}[A-Z]$/;
const NIE_PREFIX = { X: "0", Y: "1", Z: "2" };

const CIF_RE = /^[A-HJNPQRSUVW]\d{7}[0-9A-J]$/;
const CIF_LETTER_CONTROL = new Set("KPQS");
const CIF_DIGIT_CONTROL = new Set("ABEH");
const CIF_CONTROL_LETTERS = "JABCDEFGHI";

export function normalizeDniNie(value) {
  return (value || "").toUpperCase().replace(/[\s-]/g, "");
}

export function validateDniNie(value) {
  const v = normalizeDniNie(value);
  let number, letter;
  if (DNI_RE.test(v)) {
    number = v.slice(0, 8);
    letter = v.slice(8);
  } else if (NIE_RE.test(v)) {
    number = NIE_PREFIX[v[0]] + v.slice(1, 8);
    letter = v.slice(8);
  } else {
    return false;
  }
  const expected = TABLE[parseInt(number, 10) % 23];
  return expected === letter;
}

export function validateCif(value) {
  const v = normalizeDniNie(value);
  if (!CIF_RE.test(v)) return false;
  const letra = v[0];
  const digitos = v.slice(1, 8);
  const control = v[8];
  let total = 0;
  for (let i = 0; i < digitos.length; i++) {
    let d = parseInt(digitos[i], 10);
    if (i % 2 === 0) {
      d *= 2;
      d = Math.floor(d / 10) + (d % 10);
    }
    total += d;
  }
  const controlDigit = (10 - (total % 10)) % 10;
  if (CIF_DIGIT_CONTROL.has(letra)) return control === String(controlDigit);
  if (CIF_LETTER_CONTROL.has(letra)) return control === CIF_CONTROL_LETTERS[controlDigit];
  return control === String(controlDigit) || control === CIF_CONTROL_LETTERS[controlDigit];
}
